import { useId, type InputHTMLAttributes, type ReactNode } from 'react';

type Props = { label: string; error?: string; hint?: string; adornment?: ReactNode } & InputHTMLAttributes<HTMLInputElement>;

/** A labelled input. `hint` is always visible (before any typing) and is read with the field;
 *  `error` sits above it once there is one. */
export function FormField({ label, error, hint, adornment, ...input }: Props) {
  const id = useId();
  const errId = `${id}-err`;
  const hintId = `${id}-hint`;
  const describedBy = [error && errId, hint && hintId].filter(Boolean).join(' ') || undefined;
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="field-input-row">
        <input id={id} aria-invalid={!!error} aria-describedby={describedBy} {...input} />
        {adornment}
      </div>
      {error && <p id={errId} className="field-error" role="alert">{error}</p>}
      {hint && <p id={hintId} className="field-hint">{hint}</p>}
    </div>
  );
}
